import { InjectionToken, Provider } from '@angular/core';
import { RewardsWalletRepository } from './rewards-wallet.repository';
import { RewardsWalletApiService } from './rewards-wallet.service';

export const HTTP_REWARDS_WALLET_SERVICE = new InjectionToken<RewardsWalletRepository>('RewardsWalletRepository');

export const REWARDS_WALLET_API_PROVIDER: Provider = {
    provide: HTTP_REWARDS_WALLET_SERVICE,
    useClass: RewardsWalletApiService,
};
